import { FORMATS } from '@/global/services/date'
import { resolveDatetimeAppend } from '@/global/components/fields/datetimeAppend'

// These fields render through FieldsRenderer/TextField rather than
// DatetimePickerField, so the global default (the calendar image) is applied
// here, from the same shared resolver the component uses. Per field, via
// `overrides`:
//   nothing given         -> the default calendar image
//   append: { src, ... }  -> another image (any ImageField prop)
//   append: false         -> no adornment at all
//   appendIcon: 'mdi-...' -> that font icon instead of an image
//   appendIcon: ''        -> no adornment at all
function appendAdornment (overrides) {
  const { appendIcon, append } = overrides || {}
  return resolveDatetimeAppend({ appendIcon, appendImage: append })
}

export function dateFieldConfig (key, label, overrides = {}) {
  return {
    key,
    label,
    type: 'datetime-picker',
    subType: 'date',
    format: FORMATS.date,
    clickable: true,
    ...overrides,
    ...appendAdornment(overrides)
  }
}

export function timeFieldConfig (key, label, overrides = {}) {
  return {
    key,
    label,
    type: 'datetime-picker',
    subType: 'time',
    format: FORMATS.timeShort,
    clickable: true,
    ...overrides,
    ...appendAdornment(overrides)
  }
}

export function dateTimeFieldConfig (key, label, overrides = {}) {
  return {
    key,
    label,
    type: 'datetime-picker',
    format: FORMATS.datetimeShort,
    clickable: true,
    ...overrides,
    ...appendAdornment(overrides)
  }
}
